import { ThemeOptions, createTheme } from '@mui/material/styles';

const themeOptions: ThemeOptions = {
  palette: {
    mode: 'light',
    primary: {
      main: '#3A2D78',
    },
    secondary: {
      main: '#F26901',
    },
    success: {
      main: "#24A44B",
    },
    info: {
      main: "#8E8EA9"
    }
  },
  typography: {
    fontFamily: 'Mulish, Roboto',
  },
};

const theme = createTheme(themeOptions);

export default theme;